import React, {useEffect} from 'react';
import { useStateContext } from '../context/StateContext';
import VisDiv from './frontend_components/VisDiv';
import useNetworkStatus from '../hooks/useNetworkStatus';
import useNetwork from '../hooks/useNetwork';
import {LeftDownIcon} from './frontend_components/ShowHideIcon';
import FieldDropdown from './FieldDropdown';
import { addValueForDropdown, sortByLabel, addValueAndValueForDropdown} from '../lib/utils';
import SliderRegistriTemplates from './SliderRegistriTemplates';
import { useOfflineContext } from '../context/OfflineContext';

/**
 * Selector component
 * #selector
 * This component is used to select clients, sites, and filters for the registers
 * 
 * @param {Object} customers - The customers data
 * @param {Boolean} hideClients - Whether to hide the clients dropdown
 * @param {Object} clients - The clients data
 * @param {Object} sites - The sites data
 * @param {Object} viewRegisterTemplatesFilter - Whether to view the register templates filter
 * @param {Object} registerTemplateFilter - The register templates filter
 * @param {Function} setRegisterTemplateFilter - The function to set the register templates filter
 * @param {Function} closeAllInfo - The function to close all info
 */
const Selector = ({customers, hideClients, clients, sites, viewRegisterTemplatesFilter, registerTemplateFilter, setRegisterTemplateFilter, closeAllInfo=()=>{}}) => {
    const {
        client,
        setClient,
        site,
        customer,
        setCustomer,
        setSite,
        setRegister,
        setCurrentTemplate,
        setCurrentDevice,
        setDevices,
        //clients, 
        //sites, 
        setSites,
        registerTemplates,
        selectorVis,
        setSelectorVis,
        setRegisters,
        loading, 
        setLoading,
        sUser,
        LDB,
        setOffer,
        setIsWorksheet,
        setClientOrder
    } = useStateContext();

    const testing = false
    const P = "selector"

    const {offlineData, failedDevicesQueryDocs} = useOfflineContext()
   
    const networkStatus = useNetworkStatus()
    const sitesLabels = () => {
        const sitesArray = sites?.length > 0 ? sites : []
        const sitesWithNumber = sitesArray?.map?.((item)=>{
            if(item?.siteNumber){
                return {
                    ...item,
                    value:`${LDB("misc","site")} ${item?.siteNumber}: ${item?.label}`,
                    label:`${LDB("misc","site")} ${item?.siteNumber}: ${item?.label}`
                }
            }
            return {
                ...item,
                value: item.label
            }
        })
        return sitesWithNumber
    }
    const testFunction = () =>{
        console.log(client, site)
    }


    const nClients = clients?.length
    const nSites = sites?.length


    const showSelector = () => {
        if(nClients<=1 && nSites<=1) return false
        
        return true
    }
    const showClients = () => {
        if(nClients<=1) return false
        if(hideClients) return false    
        return true
    }
    const showSites = () => {
        if(nSites<=1) return false
        return true
    }

    //console.log("CUSTOMERS SELECTOR", addValueAndValueForDropdown("name",customers))

  return (
    <> 
        <VisDiv rules={[testing]}><button onClick={testFunction}>test</button></VisDiv>
        <VisDiv rules={[networkStatus, !failedDevicesQueryDocs?.length > 0, showSelector() ]} className={"selector-button-container"}>
            <LeftDownIcon show={selectorVis} setShow={setSelectorVis}/>
        </VisDiv> 

        <VisDiv rules={[showSelector(), selectorVis, networkStatus, !failedDevicesQueryDocs?.length > 0 ]} className={"selector"}>
        <VisDiv rules={[sUser?.userType == "God Mode", !hideClients, customers]}>
            <FieldDropdown
                isSearchable="isSearchable"
                initialValue={{...customer, label: customer?.name, value: customer?.name}}
                placeHolder={LDB("misc", "selectClient")}
                options={addValueAndValueForDropdown("name",customers)?.sort(sortByLabel)}
                onChange={(value) => {
                    setLoading(true)
                    //console.log("Change client")
                    setSite(undefined)
                    setSites(undefined)
                    setDevices(undefined)
                    setRegister(undefined)
                    closeAllInfo()
                    setCurrentDevice(undefined)
                    setCurrentTemplate(undefined)
                    setClient(undefined)
                    setIsWorksheet(false)
                    setOffer(undefined)
                    setClientOrder(undefined)
                    setCustomer(value)
                    //console.log("client: ", value)
                    //window.location.reload(false);
                    setLoading(false)
                    
                    }
                }
            /> 
        </VisDiv> 
            <VisDiv rules={[showClients()]}>
                <FieldDropdown
                isMulti={false}
                isSearchable="isSearchable"
                initialValue={client}
                placeHolder={LDB("misc", "selectClient")}
                options={addValueForDropdown(clients)?.sort(sortByLabel)}
                onChange={(value) => {
                    setLoading(true)
                    //console.log("Change client")
                    setSite(undefined)
                    setSites(undefined)
                    setOffer(undefined)
                    setClientOrder(undefined)
                    setDevices(undefined)
                    setRegister(undefined)
                    setRegisters(undefined)
                    closeAllInfo()
                    setIsWorksheet(false)
                    setCurrentDevice(undefined)
                    setCurrentTemplate(undefined)
                    setClient(value)
                    //console.log("client: ", value)
                    //window.location.reload(false);
                    setLoading(false)
                    
                    }
                }
            /> 
            </VisDiv>
            <VisDiv rules={[viewRegisterTemplatesFilter, client]}>
                <h4>FILTRA PER FAMIGLIA</h4>
                <SliderRegistriTemplates registerTemplateFilter={registerTemplateFilter} setRegisterTemplateFilter={setRegisterTemplateFilter} templates={registerTemplates} setLoading={setLoading}/>
     
            </VisDiv>
            <VisDiv rules={[client, showSites()]}>
                <FieldDropdown
                    key={client?._key}
                    isMulti={false}
                    initialValue={site? sitesLabels()?.find((s) => site?._id == s?._id ): {label:LDB("misc", "selectSite"),value:LDB("misc", "selectSite")}}
                    isSearchable="isSearchable"
                    placeHolder={LDB("misc", "selectSite")}
                    options={sitesLabels()?.sort(sortByLabel)}
                    onChange={(value) => {
                        setLoading(true)
                        setSite(value)
                        //setOffer(undefined)
                        setRegister(undefined)
                        closeAllInfo()
                        setCurrentDevice(undefined)
                        setCurrentTemplate(undefined)
                        //setDevices(undefined)
                        //console.log(site)
                        setLoading(false)
                    }}
                />      
            </VisDiv>                     
        </VisDiv>
    </>

  )
}

export default Selector
